"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _react = _interopRequireDefault(require("react"));

var _view = require("../view");

var _text = require("../text");

var _spacer = require("../spacer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getErrorText = function getErrorText(_ref) {
  var type = _ref.type,
      message = _ref.message;

  switch (type) {
    case 'minLength':
      return 'Too short';

    case 'maxLength':
      return 'Too long';

    case 'required':
      return 'This field is required';

    case 'manual':
      return message;

    default:
      return '';
  }
};

var Input = function Input(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      register = _ref2.register,
      options = _ref2.options,
      errors = _ref2.errors,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, ["label", "name", "register", "options", "errors", "value"]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_view.View, {
    as: "label",
    extend: labelCSS
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, null, label)), /*#__PURE__*/_react["default"].createElement(_spacer.Spacer, null), /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: inputCSS
  }, register && /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
    name: name,
    value: value,
    ref: register(options)
  })), !register && /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
    name: name,
    value: value
  }))), errors && errors[name] && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "small",
    extend: errorCSS
  }, getErrorText(errors[name])));
};

exports.Input = Input;

var labelCSS = function labelCSS(_ref3) {
  var grid = _ref3.theme.grid;
  return {
    paddingLeft: grid,
    // opacity: hasValue ? 1 : 0,
    // transform: `translateX(${hasValue ? 0 : -grid}px)`,
    transition: 'all 200ms ease-in-out'
  };
};

var inputCSS = function inputCSS(_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      grid = _ref4$theme.grid,
      layout = _ref4$theme.layout,
      shadows = _ref4$theme.shadows;
  return {
    '& > input': {
      width: '100%',
      height: 45,
      padding: "".concat(grid, "px ").concat(2 * grid, "px"),
      // background: colors.bg,
      border: "1px solid ".concat(colors.border),
      // border: "none",
      background: colors.bg,
      borderRadius: layout.radius,
      boxShadow: shadows.small,
      fontSize: 14,
      fontFamily: 'Roboto, sans-serif',
      transition: 'box-shadow 150ms ease-in-out',
      '&:focus': {
        boxShadow: shadows.big,
        borderColor: colors.primary
      },
      '&:hover': {
        boxShadow: shadows.big // borderColor: colors.primary,

      },
      '&::placeholder': {
        color: colors.diffuse // color: "red",

      }
    }
  };
};

var errorCSS = function errorCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      grid = _ref5$theme.grid;
  return {
    color: colors.red,
    marginTop: grid
  };
};